import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  FunctionField,
  ListProps,
  SelectInput,
  ReferenceInput,
  ReferenceField,
} from "react-admin";
import { Helmet } from "react-helmet";
import { SchoolIdSelected } from "utils/tools";
import React from "react";
import { notRenewedStudentStatusList } from "./const";
import CustomBooleanField from "../../components/CustomBooleanField";
import ParentLinkField from "./components/ParentLinkField";
import CustomPagination from "../../components/CustomPagination";
import ConfirmStudentRenewalButton from "./components/ConfirmStudentRenewalButton";
import UpdatedByRenewalStudentField from "./components/UpdatedByRenewalStudentField";

const StudentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <ReferenceInput
      label="Academic Year"
      source="academicYearId"
      reference="academicYears"
      filter={{
        SchoolId: Number(SchoolIdSelected()),
      }}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <SelectInput
      label="Status"
      source="Status"
      choices={notRenewedStudentStatusList}
      alwaysOn
    />
  </Filter>
);

const DueRenewalStudentList = (props: ListProps) => {
  return (
    <>
      <Helmet>
        <title>Due For Renewal Student</title>
      </Helmet>

      <List
        exporter={false}
        filters={<StudentFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        perPage={50}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
        hasCreate={false}
        pagination={<CustomPagination />}
      >
        <Datagrid>
          <TextField source="student.id" label="Student Id" />
          <FunctionField
            label="Name"
            render={(record: any) =>
              `${record.student?.firstName} ${record.student?.lastName}`
            }
          />
          <FunctionField
            label="Academic Year Info"
            render={(record: any) => `${record.currentAcademicYear?.name}`}
          />
          <ReferenceField
            label="Parent Info"
            source="student.id"
            reference="students"
            linkType={false}
          >
            <FunctionField
              render={(record: any) => <ParentLinkField record={record} />}
            />
          </ReferenceField>
          <CustomBooleanField
            source="isMaxLevel"
            textForTrueValue="Yes"
            textForFalseValue="No"
          />
          <StatusField source="status" />
          <FunctionField
            label="Updated By"
            render={(record: any) => (
              <>
                {record.updatedBy === null ? (
                  "-"
                ) : (
                  <UpdatedByRenewalStudentField data={record} />
                )}
              </>
            )}
          />
          <FunctionField
            label="Action"
            render={(record: any) => (
              <>
                {record.status === "pending" && (
                  <ConfirmStudentRenewalButton
                    id={record.id}
                    studentId={record.student.id}
                    academicYearId={record.currentAcademicYear.id}
                  />
                )}
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default DueRenewalStudentList;
